/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PolarisProductViewBlueprintsSettingsEntrypointProps } from './polarisProductViewBlueprintsSettings.entrypoint.types.tsx';

type PolarisProductViewBlueprintsSettingsEntryPointComponent = EntryPointComponent<
	{},
	{},
	PolarisProductViewBlueprintsSettingsEntrypointProps,
	{} | null
>;

export const polarisProductViewBlueprintsSettingsEntryPoint: EntryPoint<
	PolarisProductViewBlueprintsSettingsEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<PolarisProductViewBlueprintsSettingsEntryPointComponent>(
		/* webpackChunkName: "async-polaris-settings-view-blueprints", jiraSpaEntry: "async-polaris-ideas" */ './PolarisViewBlueprintsSettingsPage.tsx',
	),
	getPreloadProps: () => ({}),
});
